/*
  dump the query params in the url inside the form
  the backend then makes them available in the dashboard
  we then send these query params to the js analytics libs
  that is done in dashboard.js
*/

require([
  'jquery',
  'utils',
  'mojo-analytics',
  'parsleyjs',
], function (
  $,
  utils,
  MojoAnalytics
) {


  var $signupForm = $('.signup-form');
  var $consumerSignupForm = $('#consumer_signup_form');

  var $consumerSignupButton = $('#consumer-signup-button');
  var $businessSignupButton = $('#business-signup-button');

  // var p = 'errorUsername';

  //This is to switch signup tab from business to consumer signup
  $consumerSignupButton.click(function ()
  {
    MojoAnalytics.sendEvent({
      eventName: 'Switched User Type',
      eventData: {
        selected_user_type: 'buyer',
      },
    });
    $consumerSignupButton.addClass('active');
    $businessSignupButton.removeClass('active');
    $('#consumer_signup_form').show();
    $('#quick_signup_form').hide();

    $('.consumer_signup_modal').show();
    $('.business_signup_modal').hide();
  });

  //This is to switch signup tab from consumer to business signup
  $businessSignupButton.click(function ()
  {
    MojoAnalytics.sendEvent({
      eventName: 'Switched User Type',
      eventData: {
        selected_user_type: 'merchant',
      },
    });
    $consumerSignupButton.removeClass('active');
    $businessSignupButton.addClass('active');
    $('#consumer_signup_form').hide();
    $('#quick_signup_form').show();

    $('.consumer_signup_modal').hide();
    $('.business_signup_modal').show();
  });

  $signupForm.on('submit', function (e) {
    if (e.originalEvent) {
      e.preventDefault();
      if ($signupForm.parsley().isValid()) {
        $signupForm.submit();
      }
    }
  });

  $consumerSignupForm.on('submit', function (e) {
    if (e.originalEvent) {
      e.preventDefault();
      if ($consumerSignupForm.parsley().isValid()) {
        $consumerSignupForm.submit();
      }
    }
  });


  function createHiddenInputElem (data) {
    return '<input type="hidden" value="' + encodeURI(data.value) + '" name="' + encodeURI(data.key) + '">';
  }

  function dumpQueryParamsInSignupForm () {
    var queryParams = utils.queryStringToJSON();
    var queryParamsHtml = '';
    for (var queryParam in queryParams) {
      if (Object.prototype.hasOwnProperty.call(queryParams, queryParam)) {
        queryParamsHtml += createHiddenInputElem({ key: queryParam, value: queryParams[queryParam] });
      }
    }

    if (location.pathname.indexOf('/register') !== -1 ) {
      queryParamsHtml += createHiddenInputElem({ key: 'page_type', value: 'Standalone Register Page' });
    } else if (location.pathname.indexOf('/promos') !== -1 ) {
      queryParamsHtml += createHiddenInputElem({ key: 'page_type', value: 'Promos' });
    } else {
      queryParamsHtml += createHiddenInputElem({ key: 'page_type', value: 'Homepage' });
    }
    $signupForm.append(queryParamsHtml);
  }

  dumpQueryParamsInSignupForm();
});

define("signup", function(){});

